import React from 'react';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import { useAtom, useAtomValue } from 'jotai';
import { selectedBranchAtom, userBranchesAtom } from '../../Atoms';
import useTranslate from '../../Hooks/useTranslate';
import ReportListSheet from './ReportListSheet';

/**
 * Bottom sheet branch switcher. Mirrors the desktop switch: sets selectedBranchAtom and persists
 * to sessionStorage.
 */
const BranchSheet = function BranchSheet({ open = false, onClose = () => {} }) {
  const translate = useTranslate();
  const userBranches = useAtomValue(userBranchesAtom);
  const [selectedBranch, setSelectedBranch] = useAtom(selectedBranchAtom);

  return (
    <ReportListSheet
      open={open}
      onClose={onClose}
      title={translate('BRANCH')}
      items={(userBranches ?? []).map((branch) => ({
        key: branch?.id,
        label: branch?.branchDescription,
        Icon: ApartmentRoundedIcon,
        branch,
      }))}
      value={selectedBranch?.id}
      onChange={({ branch }) => {
        setSelectedBranch(branch);
        sessionStorage.setItem('selectedBranch', JSON.stringify(branch));
      }}
    />
  );
};

export default BranchSheet;
